import { lazy } from "react";
import type { FeatureRoute } from "../../app/route-types";
import { guarded } from "../hr/Guard";

/**
 * İşe giriş/çıkış görevleri ve zimmet. Bilgi mimarisi: docs/UX.md §2.
 * İK ekranları menüdeki yetkiyle korunur: adresle gelen yetkisiz kişi açık mesaj görür.
 */
export const routes: FeatureRoute[] = [
  { path: "gorevler", Component: lazy(() => import("./MyTasksPage")) },
  // "Görev listesi tamamlandı" bildirimi bu yolu kullanır; erişime göre süreç ayrıntısı açılır.
  { path: "gorevler/listeler/:id", Component: lazy(() => import("./ProcessPage")) },
  { path: "ik/surecler", Component: guarded(["checklists.manage"], "İşe giriş ve çıkış", () => import("./ProcessesPage")) },
  { path: "ik/surecler/sablonlar", Component: guarded(["checklists.manage"], "Görev şablonları", () => import("./TemplatesPage")) },
  { path: "ik/surecler/sablonlar/yeni", Component: guarded(["checklists.manage"], "Yeni şablon", () => import("./TemplateEditPage")) },
  { path: "ik/surecler/sablonlar/:id", Component: guarded(["checklists.manage"], "Görev şablonu", () => import("./TemplateEditPage")) },
  // Süreç ayrıntısı yöneticiye ve görev sahibine de açık (erişimi sunucu kapsamlar).
  { path: "ik/surecler/:id", Component: lazy(() => import("./ProcessPage")) },
  { path: "ik/zimmet", Component: guarded(["assets.manage"], "Zimmet", () => import("./AssetsPage")) },
  { path: "ik/zimmet/:id", Component: guarded(["assets.manage"], "Demirbaş", () => import("./AssetPage")) },
  // Ana ekrandaki "zimmet onayı" ve "zimmet verildi" bildirimi bu yolu kullanır.
  { path: "zimmetlerim", Component: lazy(() => import("./MyAssetsPage")) },
  { path: "zimmetim", Component: lazy(() => import("./Redirects").then((m) => ({ default: m.ToMyAssets }))) },
];
